export const GTM_EVENT_TYPE_SUGAR_DADDY_SIGNUP_SOI          = 'sd-signup-soi'
export const GTM_EVENT_TYPE_SUGAR_BABY_SIGNUP_SOI           = 'sb-signup-soi'
export const GTM_EVENT_TYPE_SUGAR_DADDY_SIGNUP_DOI          = 'sd-signup-doi'
export const GTM_EVENT_TYPE_SUGAR_BABY_SIGNUP_DOI           = 'sb-signup-doi'
export const GTM_EVENT_TYPE_LOGIN                           = 'login-user-data'
export const GTM_EVENT_TYPE_PAYMENT_INITIAL                 = 'initial-sale'
export const GTM_EVENT_TYPE_PAYMENT_REPEATED                = 'repeated-sale'
export const GTM_COLLECTABLE_NAME                           = 'gtm_transactions_processed'

export const GTM_EVENT_SUGGESTED_PROFILE_APPEAR             = 'notification-suggested-profile-appear'
export const GTM_EVENT_SUGGESTED_PROFILE_OPEN               = 'notification-suggested-profile-open'
export const GTM_EVENT_SUGGESTED_PROFILE_CLICK_1            = 'notification-suggested-profile-click-cta-1'
export const GTM_EVENT_SUGGESTED_PROFILE_CLICK_2            = 'notification-suggested-profile-click-cta-2'

export const GTM_EVENT_PREMIUM_SUGAR_DADDY_APPEAR           = 'notification-premium-sugar-daddy-appear'
export const GTM_EVENT_PREMIUM_SUGAR_DADDY_OPEN             = 'notification-premium-sugar-daddy-open'
export const GTM_EVENT_PREMIUM_SUGAR_DADDY_CLICK_1          = 'notification-premium-sugar-daddy-click-cta-1'
export const GTM_EVENT_PREMIUM_SUGAR_DADDY_CLICK_2          = 'notification-premium-sugar-daddy-click-cta-2'

export const GTM_EVENT_ONLINE_PROFILE_APPEAR                = 'notification-online-profile-appear'
export const GTM_EVENT_ONLINE_PROFILE_OPEN                  = 'notification-online-profile-open'
export const GTM_EVENT_ONLINE_PROFILE_CLICK_1               = 'notification-online-profile-click-cta-1'
export const GTM_EVENT_ONLINE_PROFILE_CLICK_2               = 'notification-online-profile-click-cta-2'

export const GTM_EVENT_PERFECT_MATCH_APPEAR                 = 'notification-perfect-match-appear'
export const GTM_EVENT_PERFECT_MATCH_OPEN                   = 'notification-perfect-match-open'
export const GTM_EVENT_PERFECT_MATCH_CLICK_1                = 'notification-perfect-match-click-cta-1'
export const GTM_EVENT_PERFECT_MATCH_CLICK_2                = 'notification-perfect-match-click-cta-2'

export const GTM_EVENT_REQUESTED_SECRET_ACCESS_APPEAR       = 'notification-req-secret-access-appear'
export const GTM_EVENT_REQUESTED_SECRET_ACCESS_OPEN         = 'notification-req-secret-access-open'
export const GTM_EVENT_REQUESTED_SECRET_ACCESS_CLICK_1      = 'notification-req-secret-access-click-cta-1'
export const GTM_EVENT_REQUESTED_SECRET_ACCESS_CLICK_2      = 'notification-req-secret-access-click-cta-2'

export const GTM_EVENT_SECRET_ACCESS_GRANTED_APPEAR         = 'notification-secret-access-granted-appear'
export const GTM_EVENT_SECRET_ACCESS_GRANTED_OPEN           = 'notification-secret-access-granted-open'
export const GTM_EVENT_SECRET_ACCESS_GRANTED_CLICK_1        = 'notification-secret-access-granted-click-cta-1'
export const GTM_EVENT_SECRET_ACCESS_GRANTED_CLICK_2        = 'notification-secret-access-granted-click-cta-2'

export const GTM_EVENT_FAVORITED_YOU_APPEAR                 = 'notification-favorited_you-appear'
export const GTM_EVENT_FAVORITED_YOU_OPEN                   = 'notification-favorited_you-open'
export const GTM_EVENT_FAVORITED_YOU_CLICK_1                = 'notification-favorited_you-click-cta-1'
export const GTM_EVENT_FAVORITED_YOU_CLICK_2                = 'notification-favorited_you-click-cta-2'

export const GTM_EVENT_NEW_MESSAGE_APPEAR                   = 'notification-new-message-appear'
export const GTM_EVENT_NEW_MESSAGE_OPEN                     = 'notification-new-message-open'
export const GTM_EVENT_NEW_MESSAGE_CLICK_1                  = 'notification-new-message-click-cta-1'
export const GTM_EVENT_NEW_MESSAGE_CLICK_2                  = 'notification-new-message-click-cta-2'

export const GTM_EVENT_PROFILE_VISIT_APPEAR                 = 'notification-profile-visit-appear'
export const GTM_EVENT_PROFILE_VISIT_OPEN                   = 'notification-profile-visit-open'
export const GTM_EVENT_PROFILE_VISIT_CLICK_1                = 'notification-profile-visit-click-cta-1'
export const GTM_EVENT_PROFILE_VISIT_CLICK_2                = 'notification-profile-visit-click-cta-2'

export const GTM_EVENT_ADDED_NEW_VIDEO_APPEAR               = 'notification-added-new-video-appear'
export const GTM_EVENT_ADDED_NEW_VIDEO_OPEN                 = 'notification-added-new-video-open'
export const GTM_EVENT_ADDED_NEW_VIDEO_CLICK_1              = 'notification-added-new-video-click-cta-1'
export const GTM_EVENT_ADDED_NEW_VIDEO_CLICK_2              = 'notification-added-new-video-click-cta-2'

export const GTM_EVENT_MATCH_APPEAR                         = 'notification-its-a-match-appear'
export const GTM_EVENT_MATCH_OPEN                           = 'notification-its-a-match-open'
export const GTM_EVENT_MATCH_CLICK_1                        = 'notification-its-a-match-click-cta-1'
export const GTM_EVENT_MATCH_CLICK_2                        = 'notification-its-a-match-click-cta-2'

export const GTM_EVENT_VERIFY_MODAL_VIEW                    = 'view-modal-verify-email'
export const GTM_EVENT_VERIFY_EMAIL_SEND                    = 'click-modal-verify-email-button-didnt-receive-email'
export const GTM_EVENT_VERIFY_EMAIL_SEND_CLICK              = 'click-modal-didnt-receive-email-button-resend-verification-email'
export const GTM_EVENT_EMAIL_VERIFIED_PAGE                  = 'view-modal-verified-email-address'
export const GTM_EVENT_EMAIL_VERIFIED_DISCOVER_CLICK        = 'click-modal-verified-email-address-button-discover-new-people'
export const GTM_EVENT_ADD_PROFILE_INFO_MODAL               = 'view-modal-add-profile-info'
export const GTM_EVENT_ADD_PROFILE_INFO_UPDATE              = 'click-modal-add-profile-info-button-save'
export const GTM_EVENT_GET_CREDITS_MODAL                    = 'view-modal-unlock-full-potential'
export const GTM_EVENT_GET_CREDITS_MODAL_CLICK_BUY          = 'click-modal-unlock-full-potential-button-buy-credits'
export const GTM_EVENT_GET_CREDITS_MODAL_CLICK_STAY         = 'click-modal-unlock-full-potential-button-stay-basic'
export const GTM_EVENT_PROFILE_PHOTO_MODAL                  = 'view-modal-upload-a-profile-photo'
export const GTM_EVENT_PROFILE_PHOTO_MODAL_UPLOAD           = 'click-modal-crop-profile-photo-button-save'
export const GTM_EVENT_PROFILE_PHOTO_MODAL_SKIP             = 'click-modal-upload-a-profile-photo-button-skip-for-now'
export const GTM_EVENT_ADD_PHOTOS_MODAL                     = 'view-modal-add-photos'
export const GTM_EVENT_ADD_PHOTOS_MODAL_CONTINUE            = 'click-modal-add-photos-continue'
export const GTM_EVENT_GET_VERIFIED_MODAL                   = 'view-modal-get-verified'
export const GTM_EVENT_GET_VERIFIED_MODAL_GET_VERIFIED      = 'click-modal-get-verified-button-get-verified'
export const GTM_EVENT_GET_VERIFIED_MODAL_STAY              = 'click-modal-get-verified-button-stay-basic'
export const GTM_EVENT_BUY_CREDITS_CLICK                    = 'click-button-buy-credits-header-desk-menu-mob'
export const GTM_EVENT_PAGE_LINK_CLICK                      = 'click-button-menu-{page}'
export const GTM_EVENT_VIEW_CREDITS_PAGE                    = 'view-credits-page'
export const GTM_EVENT_SELECT_PACKAGE                       = 'click-credits-page-package-{id}'
export const GTM_EVENT_PAYMENT_FAILED_PAGE                  = 'view-payment-failed-page'
export const GTM_EVENT_PAYMENT_FAILED_TRY_AGAIN             = 'click-payment-failed-page-button-try-again'
export const GTM_EVENT_PAYMENT_SUCCESS                      = 'view-payment-completed-page'
export const GTM_EVENT_PAYMENT_SUCCESS_BACK_HOME            = 'click-payment-completed-page-button-back-home'

export const GTM_EVENT_DATING_OFFER_MODAL                   = 'view-modal-dating-offers'
export const GTM_EVENT_DATING_OFFER_SUCCESS                 = 'click-modal-dating-offers-button-save'
export const GTM_EVENT_DATING_OFFER_APPEAR                  = 'notification-dating-offer-appear'
export const GTM_EVENT_DATING_OFFER_OPEN                    = 'notification-dating-offer-open'
export const GTM_EVENT_DATING_OFFER_CTA_1                   = 'notification-dating-offer-click-cta-1'
export const GTM_EVENT_DATING_OFFER_CTA_2                   = 'notification-dating-offer-click-cta-2'

export const SEARCH_ORDER_BY_FILTER                         = 'order-by-filter'
export const SEARCH_DISTANCE_FILTER                         = 'distance-filter'
export const SEARCH_LOCATION_FILTER                         = 'search-location'
export const SEARCH_BODY_TYPE_FILTER                        = 'body-type-filter'
export const SEARCH_LOOKING_FOR_FILTER                      = 'looking-for-filter'
export const SEARCH_AGE_FILTER                              = 'age-filter'
export const SEARCH_DRINKING_FILTER                         = 'drinking-filter'
export const SEARCH_EDUCATION_FILTER                        = 'education-filter'
export const SEARCH_ETHNICITY_FILTER                        = 'ethnicity-filter'
export const SEARCH_HAIR_COLOR_FILTER                       = 'hair-color-fllter'
export const SEARCH_EYE_COLOR_FILTER                        = 'eye-color-filter'
export const SEARCH_HEIGHT_FILTER                           = 'height-filter'
export const SEARCH_PIERCINGS_FILTER                        = 'piercings-filter'
export const SEARCH_SMOKING_FILTER                          = 'smoking-filter'
export const SEARCH_TATTOOS_FILTER                          = 'tattoos-filter'
export const SEARCH_VERIFIED_ONLY_FILTER                    = 'verified-only-filter'
export const SEARCH_HIDE_CONTACTED_FILTER                   = 'hide-contacted-filter'
export const SEARCH_COUNTRY_STRICT_FILTER                   = 'country-only-filter'
export const REQUEST_SECRET_GALLERY_ACCESS                  = 'button-click-request-access'
export const MESSAGE_ME_CLICK                               = 'button-click-message-me'
export const ADD_TO_FAVORITES                               = 'favorite-added'
export const BLOCK_USER                                     = 'user-report'
export const REPORT_USER                                    = 'user-block'

export const PUSH_NOTIFICATION_PROMPT_SHOW                  =  'view_s1_app_modal_allow_push'
export const PUSH_NOTIFICATION_PROMPT_ACCEPT                = 'click_allow_app_modal_allow_push'
export const PUSH_NOTIFICATION_PROMPT_SKIP                  = 'click_skip_app_modal_allow_push'
export const PUSH_NOTIFICATION_ACCEPT_FLOW_SHOW             = 'view_s2_app_modal_allow_push'
export const PUSH_NOTIFICATION_ACCEPT_FLOW_CLOSE            = 'closed_s2_app_modal_allow_push'
export const PUSH_NOTIFICATION_BROWSER_REQUEST               = 'view_browser_modal_allow_push'
export const PUSH_NOTIFICATION_BROWSER_ALLOW                = 'click_allow_browser_modal_allow_push'
export const PUSH_NOTIFICATION_BROWSER_REJECT               = 'click_block_browser_modal_allow_push'

export const VIP_RESULT_CLICK                               = 'viewed_profile_vip_section'

export const GTM_EVENT_DATING_NET_WORTH_MODAL                   = 'view-modal-net-worth'
export const GTM_EVENT_DATING_NET_WORTH_SUCCESS                 = 'click-modal-net-worth-button-save'

export const GTM_EVENT_DATING_OFFER_MODAL_SKIP = 'click-modal-dating-offers-button-skip'
export const GTM_EVENT_DATING_NET_WORTH_MODAL_SKIP                   = 'click-modal-net-worth-button-skip'

export const GTM_EVENT_VIEW_FUND_BANNER_FREE = 'banner_fundaccount_freeuser_view'
export const GTM_EVENT_VIEW_FUND_BANNER_PAID = 'banner_fundaccount_paiduser_view'

export const GTM_EVENT_CLICK_FUND_BANNER_FREE = 'banner_fundaccount_freeuser_click'
export const GTM_EVENT_CLICK_FUND_BANNER_PAID = 'banner_fundaccount_paiduser_click'

export const GTM_EVENT_DISMISS_FUND_BANNER_FREE = 'banner_fundaccount_freeuser_dismiss'
export const GTM_EVENT_DISMISS_FUND_BANNER_PAID = 'banner_fundaccount_paiduser_dismiss'

export const GTM_EVENT_PURCHASE_FUND_BANNER_FREE = 'banner_fundaccount_freeuser_purchase'
export const GTM_EVENT_PURCHASE_FUND_BANNER_PAID = 'banner_fundaccount_paiduser_purchase'

export const GTM_BUY_CREDITS_TESTS_TRIGGER1_A_CREDITS_PAGE_VIEW = 'fu-buy-credits-tests-trigger1-test-a-credits-page-view'
export const GTM_BUY_CREDITS_TESTS_TRIGGER1_A_PURCHASED_CREDITS = 'fu-buy-credits-tests-trigger1-test-a-purchased-credits'
export const GTM_BUY_CREDITS_TESTS_TRIGGER1_B_CREDITS_PAGE_VIEW = 'fu-buy-credits-tests-trigger1-test-b-popup-view'
export const GTM_BUY_CREDITS_TESTS_TRIGGER1_B_PURCHASED_CREDITS = 'fu-buy-credits-tests-trigger1-test-b-purchased-credits'

export const GTM_BUY_CREDITS_TESTS_TRIGGER2_A_CREDITS_PAGE_VIEW = 'fu-buy-credits-tests-trigger2-test-a-credits-page-view'
export const GTM_BUY_CREDITS_TESTS_TRIGGER2_A_PURCHASED_CREDITS = 'fu-buy-credits-tests-trigger2-test-a-purchased-credits'
export const GTM_BUY_CREDITS_TESTS_TRIGGER2_B_CREDITS_PAGE_VIEW = 'fu-buy-credits-tests-trigger2-test-b-popup-view'
export const GTM_BUY_CREDITS_TESTS_TRIGGER2_B_PURCHASED_CREDITS = 'fu-buy-credits-tests-trigger2-test-b-purchased-credits'

export const GTM_BUY_CREDITS_TESTS_TRIGGER3_CREDITS_PAGE_VIEW = 'fu-buy-credits-tests-trigger3-popup-view'
export const GTM_BUY_CREDITS_TESTS_TRIGGER3_PURCHASED_CREDITS = 'fu-buy-credits-tests-trigger3-purchased-credits'

export const GTM_BUY_CREDITS_TESTS_TRIGGER4_CREDITS_PAGE_VIEW = 'fu-buy-credits-tests-trigger4-popup-view'
export const GTM_BUY_CREDITS_TESTS_TRIGGER4_PURCHASED_CREDITS = 'fu-buy-credits-tests-trigger4-purchased-credits'

export const GTM_BUY_CREDITS_TESTS_TRIGGER5_CREDITS_PAGE_VIEW = 'fu-buy-credits-tests-trigger5-credits-page-popup-view'
export const GTM_BUY_CREDITS_TESTS_TRIGGER5_PURCHASED_CREDITS = 'fu-buy-credits-tests-trigger5-purchased-credits'

export const GTM_BUY_CREDITS_TESTS_TRIGGER6_A_CREDITS_PAGE_VIEW = 'fu-buy-credits-tests-trigger6-test-a-credits-page-view'
export const GTM_BUY_CREDITS_TESTS_TRIGGER6_A_PURCHASED_CREDITS = 'fu-buy-credits-tests-trigger6-test-a-purchased-credits'
export const GTM_BUY_CREDITS_TESTS_TRIGGER6_B_CREDITS_PAGE_VIEW = 'fu-buy-credits-tests-trigger6-test-b-popup-view'
export const GTM_BUY_CREDITS_TESTS_TRIGGER6_B_PURCHASED_CREDITS = 'fu-buy-credits-tests-trigger6-test-b-purchased-credits'

export const GTM_BUY_CREDITS_TESTS_TRIGGER7_A_CREDITS_PAGE_VIEW = 'fu-buy-credits-tests-trigger7-popup-view'
export const GTM_BUY_CREDITS_TESTS_TRIGGER7_A_PURCHASED_CREDITS = 'fu-buy-credits-tests-trigger7-purchased-credits'

export const GTM_BUY_CREDITS_TESTS_TRIGGER8_A_CREDITS_PAGE_VIEW = 'fu-buy-credits-tests-trigger8-popup-view'
export const GTM_BUY_CREDITS_TESTS_TRIGGER8_A_PURCHASED_CREDITS = 'fu-buy-credits-tests-trigger8-purchased-credits'

export const GTM_BUTTON_BUY_CREDIT_PURCHASE = 'button-buy-credits-header-desk-menu-mob-purchased-credits'

export const GTM_STAGE2_PROMO_BANNER_VIEW = 'stage2_promo_banner_view'
export const GTM_STAGE2_PROMO_BANNER_CLICK = 'stage2_promo_banner_click'
export const GTM_STAGE2_PROMO_BANNER_PURCHASE = 'stage2_promo_banner_purchase'
export const GTM_STAGE2_GAMIFIED_VIEW = 'stage2_gamified_view'
export const GTM_STAGE2_GAMIFIED_CLICK = 'stage2_gamified_click'
export const GTM_STAGE2_PURCHASE_DAY1 = 'stage2_gamified_purchase_day1'
export const GTM_STAGE2_PURCHASE_DAY2 = 'stage2_gamified_purchase_day2'
export const GTM_STAGE2_PURCHASE_DAY3 = 'stage2_gamified_purchase_day3'

